export const name = 'rendererConfiguration' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
